import I18n from 'lib/i18n'
import './styles.scss'
import React from 'react'

import { newCoursePath } from 'lib/utils/links'

export default function TeacherSignupPromotion () {
  return (
    <div id='homepage-signup'>
      <div className='grid'>
        <div className='col-1-1'>
          <h2 className='homepage'>{I18n.t('react.homepage.teacher_signup.title')}</h2>
          <p>{I18n.t('react.homepage.teacher_signup.subtitle')}</p>
          <button className='button' role='button' onClick={() => (window.location.href = newCoursePath())}>
            {I18n.t('react.homepage.teacher_signup.button')}
          </button>
        </div>
      </div>
    </div>
  )
}
